import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Table from "../../../core/pagination/datatable.jsx";
import dayjs from "dayjs";
import updateLocale from "dayjs/plugin/updateLocale";
dayjs.extend(updateLocale);
dayjs.updateLocale("en", {
  weekStart: 1,
});
import enUS from "antd/es/calendar/locale/en_US";
import { Spin, Tooltip, Input, Calendar, Select } from "antd";
import Swal from "sweetalert2";
import { Edit, Save, X } from "feather-icons-react";
import { ROLL_CALL_API_BASE_URL } from "../RollCall/RollCallConfig/RollCallConfig.js";
import ImageWithBasePath from "../../../core/img/imagewithbasebath.jsx";
import CountUp from "react-countup";
const { Option } = Select;

const KpiResponses = () => {
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);

  const [value, setValue] = useState(dayjs());
  const [kpiData, setKpiData] = useState({
    daily: [],
    weekly: [],
    monthly: [],
  });
  const [kpiLoading, setKpiLoading] = useState(false);
  const [editingKey, setEditingKey] = useState(null);
  const [editRow, setEditRow] = useState({});
  const [kpiSubmitLoading, setKpiSubmitLoading] = useState(false);
  const [calendarData, setCalendarData] = useState({});
  const [KPICalenderLoading, setKPICalenderLoading] = useState(false);
  const [selectedCalendarDate, setSelectedCalendarDate] = useState(
    dayjs().format("YYYY-MM-DD"),
  );
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [branchsLoading, setBranchesLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("daily");
  const startYear = 2026;
  const currentYearCalender = dayjs().year();
  const [dashboardCounts, setDashboardCounts] = useState(null);
  const [dashboardCountsLoading, setDashboardCountsLoading] = useState(false);
  console.log(dashboardCounts, "dashboardCounts");
  const years = [];
  for (let i = startYear; i <= currentYearCalender; i++) {
    years.push(i);
  }

  const userData = JSON.parse(sessionStorage.getItem("userData"));
  const regId = userData?.UserId;

  const navigate = useNavigate();
  const isEditing = (record) => record.key === editingKey;

  const handleEdit = (record) => {
    setEditingKey(record.key);
    setEditRow({ ...record });
  };
  const handleInputChange = (e, field) => {
    setEditRow({
      ...editRow,
      [field]: e.target.value,
    });
  };

  const handleKpiSave = async () => {
    try {
      setKpiSubmitLoading(true);

      const payload = {
        Id: editRow.id,
        Achieved: Number(editRow.Achieved),
        Notes: editRow.Notes,
        UserId: regId,
        BranchId: editRow.BranchId,
      };

      const response = await fetch(
        `${ROLL_CALL_API_BASE_URL}kpi/updatekpiresponce`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tokenData}`,
          },
          body: JSON.stringify(payload),
        },
      );

      const data = await response.json();

      if (!response.ok || !data?.status) {
        throw new Error(data?.message || "Failed to update KPI");
      }

      await Swal.fire({
        icon: "success",
        title: "Success",
        text: "KPI updated successfully",
        confirmButtonText: "OK",
      });

      fetchKPI(editRow.KPIGroupId);
      setEditingKey(null);
    } catch (error) {
      console.error("Error updating KPI:", error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "Something went wrong",
      });
    } finally {
      setKpiSubmitLoading(false);
    }
  };

  const fetchKPIDates = async (dateValue, selectedBranch) => {
    try {
      setKPICalenderLoading(true);
      const fromDate = dayjs(dateValue).startOf("month").format("YYYY-MM-DD");
      const toDate = dayjs(dateValue).endOf("month").format("YYYY-MM-DD");
      const response = await fetch(
        `${ROLL_CALL_API_BASE_URL}ess/kpi/getkpidates?Fromdate=${fromDate}&Todate=${toDate}&SuperId=${superIdData}&BranchId=${selectedBranch}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${tokenData}`,
          },
        },
      );

      const data = await response.json();

      if (!data?.status) return;

      const groupedDetails = {};
      const groupedBadges = {};

      data.ResultData.forEach((item) => {
        const dateKey = dayjs(item.DateOfTransaction).format("YYYY-MM-DD");

        // badge logic
        let color = "danger";
        if (item.IsProcessed) {
          color = "success";
        } else if (!item.IsProcessed && item.IsValid) {
          color = "warning";
        }

        const letter = item.GroupName?.charAt(0)?.toUpperCase();

        // badges
        if (!groupedBadges[dateKey]) {
          groupedBadges[dateKey] = {};
        }
        groupedBadges[dateKey][letter] = color;

        // full details
        if (!groupedDetails[dateKey]) {
          groupedDetails[dateKey] = [];
        }
        groupedDetails[dateKey].push(item);
      });

      setCalendarData(groupedBadges);
    } catch (err) {
      console.error("Error fetching KPI dates:", err);
    } finally {
      setKPICalenderLoading(false);
    }
  };

  useEffect(() => {
    if (tokenData && superIdData) {
      fetchKPIDates(value, selectedBranch);
    }
  }, [tokenData, selectedBranch]);

  const handleDateSelect = (value) => {
    let dateObj;

    if (typeof value === "string") {
      dateObj = dayjs(value);
    } else {
      dateObj = value;
    }

    const dateKey = dateObj.format("YYYY-MM-DD");

    setSelectedCalendarDate(dateKey);
  };

  //region session
  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  const fetchKPI = () => {
    if (!selectedBranch) return;

    setKpiLoading(true);

    const superId = sessionStorage.getItem("superId");

    fetch(
      `${ROLL_CALL_API_BASE_URL}ess/kpi/getkpiresponse?KPIGroup=0&BranchId=${selectedBranch}&Fromdate=${selectedCalendarDate}&Todate=${selectedCalendarDate}&SuperId=${superId}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${tokenData}`,
        },
      },
    )
      .then((res) => res.json())
      .then((data) => {
        console.log(data, "FULL API");

        if (data.Status) {
          const result = data.ResultData || {};

          const formattedData = {
            daily: (result.Daily || []).map((item, index) => ({
              ...item,
              key: item.Id || index,
            })),

            weekly: (result.Weekly || []).map((item, index) => ({
              ...item,
              key: item.Id || index,
            })),

            monthly: (result.Monthly || []).map((item, index) => ({
              ...item,
              key: item.Id || index,
            })),
          };

          console.log(formattedData, "FORMATTED DATA");

          setKpiData(formattedData);
          if (formattedData.daily.length > 0) {
            setActiveTab("daily");
          } else if (formattedData.weekly.length > 0) {
            setActiveTab("weekly");
          } else if (formattedData.monthly.length > 0) {
            setActiveTab("monthly");
          } else {
            setActiveTab("");
          }
        }
      })
      .catch((err) => {
        console.error("KPI API Error:", err);

        setKpiData({
          daily: [],
          weekly: [],
          monthly: [],
        });
      })
      .finally(() => setKpiLoading(false));
  };

  const fetchBranches = () => {
    setBranchesLoading(true);

    if (tokenData && superIdData) {
      fetch(
        `${ROLL_CALL_API_BASE_URL}portal/branch/getbranch?superid=${superIdData}`,
        {
          headers: {
            Authorization: `Bearer ${tokenData}`,
          },
        },
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status && data.ResultData.length > 0) {
            setBranches(data.ResultData);

            // Set first branch as default
            setSelectedBranch(data.ResultData[0].branchid);
          } else {
            console.error("Unexpected API response:", data);
          }
        })
        .catch((error) => {
          console.error("Error fetching branches", error);
        })
        .finally(() => setBranchesLoading(false));
    }
  };

  useEffect(() => {
    const fetchDashboardCounts = async () => {
      if (!superIdData) {
        return;
      }
      try {
        setDashboardCountsLoading(true);

        const response = await fetch(
          `${ROLL_CALL_API_BASE_URL}portal/kpi/getKPIDashBoardCounts?SuperId=${superIdData}`,
          {
            headers: { Authorization: `Bearer ${tokenData}` },
          },
        );

        const data = await response.json();

        if (data?.status) {
          setDashboardCounts(data.ResultData[0]);
        } else {
          console.error("API returned false status");
        }
      } catch (error) {
        console.error("Error fetching dashboard counts:", error);
      } finally {
        setDashboardCountsLoading(false);
      }
    };

    fetchDashboardCounts();
  }, [superIdData]);

  useEffect(() => {
    fetchBranches();
  }, [regId, tokenData]);

  useEffect(() => {
    if (selectedCalendarDate) {
      handleDateSelect(selectedCalendarDate);
    }
    setActiveTab("daily");
    fetchKPI();
  }, [selectedCalendarDate, calendarData, selectedBranch]);
  const handleCancelEdit = () => {
    setEditingKey("");
    setEditRow({});
  };

  const kpiColumns = [
    {
      title: "Metric",
      dataIndex: "MetricName",
      render: (text) => {
        if (!text) return "-";
        return (
          <Tooltip title={text}>
            {text.length > 25 ? text.slice(0, 25) + "..." : text}
          </Tooltip>
        );
      },
    },

    {
      title: "Target",
      dataIndex: "Target",
      render: (val) => (
        <span>
          {val === 0 || val === null || val === undefined ? "-" : val}
        </span>
      ),
    },
    {
      title: "Achieved",
      dataIndex: "Achieved",
      render: (val, record) => {
        return isEditing(record) ? (
          <Input
            type="number"
            min={0}
            value={editRow.Achieved}
            onChange={(e) => handleInputChange(e, "Achieved")}
            onWheel={(e) => e.target.blur()}
            onKeyDown={(e) => {
              if (["-", "+", "e", "E"].includes(e.key)) {
                e.preventDefault();
              }
            }}
          />
        ) : (
          (val ?? "-")
        );
      },
    },

    {
      title: "Notes",
      dataIndex: "Notes",
      render: (text, record) => {
        return isEditing(record) ? (
          <Input
            value={editRow.Notes}
            onChange={(e) => handleInputChange(e, "Notes")}
          />
        ) : text ? (
          <Tooltip title={text}>
            <i
              className="fa-regular fa-note-sticky text-primary"
              style={{ cursor: "pointer", fontSize: "16px" }}
            />
          </Tooltip>
        ) : (
          "-"
        );
      },
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => {
        const editing = isEditing(record);
        return (
          <div>
            {editing ? (
              <>
                <Tooltip title="Save">
                  <button
                    className="btn btn-sm btn-light border-0"
                    onClick={handleKpiSave}
                  >
                    <Save size={16} className="text-success" />
                  </button>
                </Tooltip>
                <Tooltip title="Cancel">
                  <button
                    className="btn btn-sm btn-light border-0"
                    onClick={handleCancelEdit}
                  >
                    <X size={16} className="text-danger" />
                  </button>
                </Tooltip>
              </>
            ) : (
              <Tooltip title="Edit">
                <button
                  className="btn btn-sm btn-light border-0"
                  onClick={() => handleEdit(record)}
                >
                  <Edit size={16} className="text-primary" />
                </button>
              </Tooltip>
            )}
          </div>
        );
      },
    },
  ];
  const headerRender = ({ value, onChange }) => {
    const year = value.year();
    const month = value.month();

    return (
      <div
        className="d-flex justify-content-between align-items-center p-2"
        //  style={{ padding: 8, display: "flex", gap: 10 }}
      >
        <div>
          <Select
            className="me-1"
            value={year}
            onChange={(newYear) => {
              const newValue = value.clone().year(newYear);
              onChange(newValue);
              setValue(newValue);
              fetchKPIDates(newValue);
            }}
          >
            {years.map((y) => (
              <Select.Option key={y} value={y}>
                {y}
              </Select.Option>
            ))}
          </Select>

          <Select
            value={month}
            style={{ width: 105 }}
            onChange={(newMonth) => {
              const newValue = value.clone().month(newMonth);
              onChange(newValue);
              setValue(newValue);
              fetchKPIDates(newValue);
            }}
          >
            {Array.from({ length: 12 }, (_, i) => (
              <Select.Option key={i} value={i}>
                {dayjs().month(i).format("MMMM")}
              </Select.Option>
            ))}
          </Select>
        </div>

        <div>
          <div className="d-flex">
            <div className="d-flex  align-items-center">
              <span
                className={`badge rounded-pill text-white badge-sm bg-success me-1`}
                style={{
                  width: "15px",
                  height: "15px",
                  display: "inline-flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "0.55rem",
                }}
              ></span>
              Done
              <span
                className={`badge rounded-pill text-white badge-sm bg-warning mx-1`}
                style={{
                  width: "15px",
                  height: "15px",
                  display: "inline-flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "0.55rem",
                }}
              ></span>
              Pending
              <span
                className={`badge rounded-pill text-white badge-sm bg-danger mx-1`}
                style={{
                  width: "15px",
                  height: "15px",
                  display: "inline-flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "0.55rem",
                }}
              ></span>
              Due
            </div>
          </div>
          {/* <div className="d-flex">D-Daily, W-Weekly, M-Monthly</div> */}
        </div>
      </div>
    );
  };

  const dateCellRender = (value) => {
    const dateKey = value.format("YYYY-MM-DD");
    const badges = calendarData[dateKey];

    if (!badges) return null;

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: 2,
          marginTop: 2,
        }}
      >
        {Object.keys(badges).map((letter) => (
          <span
            key={letter}
            className={`badge rounded-pill text-white bg-${badges[letter]}`}
            style={{
              width: "15px",
              height: "15px",
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: "0.55rem",
            }}
          >
            {letter}
          </span>
        ))}
      </div>
    );
  };

  const formatAmount = (value) => {
    if (!value) return "0";

    const num = Number(value.toString().replace(/,/g, ""));

    if (num >= 10000000) {
      return (num / 10000000).toFixed(1).replace(/\.0$/, "") + "Cr";
    } else if (num >= 100000) {
      return (num / 100000).toFixed(1).replace(/\.0$/, "") + "L";
    } else if (num >= 1000) {
      return (num / 1000).toFixed(1).replace(/\.0$/, "") + "K";
    } else {
      return num.toString();
    }
  };
  return (
    <div>
      {kpiSubmitLoading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      <div className="page-wrapper pt-5">
        <div className="content">
          <div className="row pt-5">
            <div className="col d-flex">
              <div className="card dash-widget w-100">
                <div className="card-body d-flex align-items-center">
                  <div className="dash-widgetimg">
                    <span>
                      <ImageWithBasePath
                        src="assets/img/icons/diagostic.svg"
                        alt="img"
                      />
                    </span>
                  </div>
                  <div className="dash-widgetcontent">
                    <h5>
                      {dashboardCountsLoading ? (
                        <Spin size="small" />
                      ) : (
                        <CountUp
                          className="counters"
                          start={0}
                          end={formatAmount(dashboardCounts?.YearCollection)}
                          duration={3}
                          prefix=""
                        />
                      )}
                    </h5>
                    <p className="mb-0">Collections YTD</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col d-flex">
              <div className="card dash-widget dash1 w-100">
                <div className="card-body d-flex align-items-center">
                  <div className="dash-widgetimg">
                    <span>
                      <ImageWithBasePath
                        src="assets/img/icons/graph.svg"
                        alt="img"
                      />
                    </span>
                  </div>
                  <div className="dash-widgetcontent">
                    <h5>
                      <span className="counters">
                        {dashboardCountsLoading ? (
                          <Spin size="small" />
                        ) : (
                          <CountUp
                            className="counters"
                            start={0}
                            end={formatAmount(dashboardCounts?.YearExpenses)}
                            duration={3}
                            prefix=""
                          />
                        )}
                      </span>
                    </h5>
                    <p className="mb-0">Expenses YTD</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col d-flex">
              <div className="card dash-widget dash2 w-100">
                <div className="card-body d-flex align-items-center">
                  <div className="dash-widgetimg">
                    <span>
                      <ImageWithBasePath
                        src="assets/img/icons/cash.svg"
                        alt="img"
                      />
                    </span>
                  </div>
                  <div className="dash-widgetcontent">
                    <h5>
                      <span className="counters">
                        {dashboardCountsLoading ? (
                          <Spin size="small" />
                        ) : (
                          <CountUp
                            className="counters"
                            start={0}
                            end={formatAmount(
                              dashboardCounts?.CurrentMonthExpenses,
                            )}
                            duration={3}
                            prefix=""
                          />
                        )}
                      </span>
                    </h5>
                    <p className="mb-0">
                      {" "}
                      This Month <br />
                      Expenses{" "}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col d-flex">
              <div className="card dash-widget dash3 w-100">
                <div className="card-body d-flex align-items-center">
                  <div className="dash-widgetimg">
                    <span>
                      <ImageWithBasePath
                        src="assets/img/icons/diagostic.svg"
                        alt="img"
                      />
                    </span>
                  </div>
                  <div className="dash-widgetcontent">
                    <h5>
                      <span className="counters">
                        {dashboardCountsLoading ? (
                          <Spin size="small" />
                        ) : (
                          <CountUp
                            className="counters"
                            start={0}
                            end={dashboardCounts?.TotalExpenses}
                            duration={3}
                            prefix=""
                          />
                        )}
                      </span>
                    </h5>
                    <p className="mb-0">
                      {" "}
                      This Month <br />
                      Collection
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col d-flex">
              <div className="card dash-widget dash3 w-100">
                <div className="card-body d-flex align-items-center">
                  <div className="dash-widgetimg">
                    <span>
                      <ImageWithBasePath
                        src="assets/img/icons/diagostic.svg"
                        alt="img"
                      />
                    </span>
                  </div>
                  <div className="dash-widgetcontent">
                    <h5>
                      <span className="counters">
                        {dashboardCountsLoading ? (
                          <Spin size="small" />
                        ) : (
                          <CountUp
                            className="counters"
                            start={0}
                            end={dashboardCounts?.TotalExpenses}
                            duration={3}
                            prefix=""
                          />
                        )}
                      </span>
                    </h5>
                    <p className="mb-0"> Last Month KPI</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <style>
              {`
                .custom-calendar .ant-picker-calendar-date-content {
                  height: 25px !important;
                  overflow-y: hidden !important;
                }

                .custom-calendar .ant-picker-cell-inner {
                  min-height: 25px !important;
                  padding: 4px !important;
                }
              `}
            </style>
            <div className="col-5 custom-calendar">
              <Calendar
                locale={enUS}
                loading={KPICalenderLoading}
                disabledDate={(current) =>
                  current && current > dayjs().endOf("day")
                }
                onSelect={handleDateSelect}
                value={value}
                onChange={(newValue) => {
                  setValue(newValue);
                  fetchKPIDates(newValue);
                }}
                headerRender={headerRender}
                dateCellRender={dateCellRender}
              />
            </div>
            <div className="col-7 d-flex">
              <div className="flex-fill">
                <div className="card table-list-card no-search flex-fill">
                  {/* 🔹 Header with Tabs */}
                  <div className="card-header d-flex justify-content-between align-items-center flex-wrap pb-0 pt-2">
                    {/* Tabs */}
                    <ul className="nav nav-tabs nav-tabs-bottom mb-3">
                      {kpiData.daily.length > 0 && (
                        <li className="nav-item">
                          <Link
                            className={`nav-link ${activeTab === "daily" ? "active" : ""}`}
                            to="#daily"
                            data-bs-toggle="tab"
                            onClick={() => setActiveTab("daily")}
                          >
                            <i className="fa-solid fa-chart-line me-2"></i>
                            Daily KPI
                          </Link>
                        </li>
                      )}

                      {kpiData.weekly.length > 0 && (
                        <li className="nav-item">
                          <Link
                            className={`nav-link ${activeTab === "weekly" ? "active" : ""}`}
                            to="#weekly"
                            data-bs-toggle="tab"
                            onClick={() => setActiveTab("weekly")}
                          >
                            <i className="fa-solid fa-calendar-week me-2"></i>
                            Weekly
                          </Link>
                        </li>
                      )}

                      {kpiData.monthly.length > 0 && (
                        <li className="nav-item">
                          <Link
                            className={`nav-link ${activeTab === "monthly" ? "active" : ""}`}
                            to="#monthly"
                            data-bs-toggle="tab"
                            onClick={() => setActiveTab("monthly")}
                          >
                            <i className="fa-solid fa-calendar-alt me-2"></i>
                            Monthly
                          </Link>
                        </li>
                      )}
                    </ul>

                    {/* Right Button */}
                    {/* <Link to="/rollcall/attendance">
                      <button className="btn btn-secondary btn-sm">
                        <i className="fa-solid fa-list-ul me-2"></i>Show all
                      </button>
                    </Link> */}
                    <Select
                      value={selectedBranch}
                      loading={branchsLoading}
                      onChange={(value) => setSelectedBranch(value)}
                      style={{ width: 150 }}
                    >
                      {branches.map((branch) => (
                        <Option key={branch.branchid} value={branch.branchid}>
                          {branch.Name}
                        </Option>
                      ))}
                    </Select>
                  </div>

                  {/* 🔹 Tab Content */}
                  <div className="card-body pb-0">
                    <div className="tab-content">
                      {/* Daily */}
                      <div
                        className={`tab-pane fade ${
                          activeTab === "daily" ? "show active" : ""
                        }`}
                        id="daily"
                      >
                        {kpiLoading ? (
                          <div className="text-center my-4">
                            <Spin size="large" />
                          </div>
                        ) : kpiData.daily.length > 0 ? (
                          <Table
                            columns={kpiColumns}
                            dataSource={kpiData.daily}
                            rowKey="Id"
                            showSizeChangerProp={false}
                          />
                        ) : (
                          <p className="text-center my-4">No Daily KPI data</p>
                        )}
                      </div>

                      {/* Weekly */}
                      <div
                        className={`tab-pane fade ${
                          activeTab === "weekly" ? "show active" : ""
                        }`}
                        id="weekly"
                      >
                        {kpiLoading ? (
                          <div className="text-center my-4">
                            <Spin size="large" />
                          </div>
                        ) : kpiData.weekly.length > 0 ? (
                          <Table
                            columns={kpiColumns}
                            dataSource={kpiData.weekly}
                            rowKey="Id"
                            showSizeChangerProp={false}
                          />
                        ) : (
                          <p className="text-center my-4">No Weekly KPI data</p>
                        )}
                      </div>

                      {/* Monthly */}
                      <div
                        className={`tab-pane fade ${
                          activeTab === "monthly" ? "show active" : ""
                        }`}
                        id="monthly"
                      >
                        {kpiLoading ? (
                          <div className="text-center my-4">
                            <Spin size="large" />
                          </div>
                        ) : kpiData.monthly.length > 0 ? (
                          <Table
                            columns={kpiColumns}
                            dataSource={kpiData.monthly}
                            rowKey="Id"
                            showSizeChangerProp={false}
                          />
                        ) : (
                          <p className="text-center my-4">
                            No Monthly KPI data
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KpiResponses;
